import { render, staticRenderFns } from "./TrainingSessionInfos.vue?vue&type=template&id=379f4538"
import script from "./TrainingSessionInfos.vue?vue&type=script&lang=js"
export * from "./TrainingSessionInfos.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports